// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.wp-block-columns {
  display: flex;
  margin-bottom: 1.75em;
  box-sizing: border-box;
  flex-wrap: wrap !important;
  align-items: normal !important;
}
@media (min-width: 782px) {
  .wp-block-columns {
    flex-wrap: nowrap !important;
  }
}
.wp-block-columns.are-vertically-aligned-top {
  align-items: flex-start;
}
.wp-block-columns.are-vertically-aligned-center {
  align-items: center;
}
.wp-block-columns.are-vertically-aligned-bottom {
  align-items: flex-end;
}
@media (max-width: 781px) {
  .wp-block-columns:not(.is-not-stacked-on-mobile) > .wp-block-column {
    flex-basis: 100% !important;
  }
}
@media (min-width: 782px) {
  .wp-block-columns:not(.is-not-stacked-on-mobile) > .wp-block-column {
    flex-basis: 0;
    flex-grow: 1;
  }
  .wp-block-columns:not(.is-not-stacked-on-mobile)
    > .wp-block-column[style*="flex-basis"] {
    flex-grow: 0;
  }
}
.wp-block-columns.is-not-stacked-on-mobile {
  flex-wrap: nowrap !important;
}
.wp-block-columns.is-not-stacked-on-mobile > .wp-block-column {
  flex-basis: 0;
  flex-grow: 1;
}
.wp-block-columns.is-not-stacked-on-mobile
  > .wp-block-column[style*="flex-basis"] {
  flex-grow: 0;
}

.wp-block-column {
  flex-grow: 1;
  min-width: 0;
  word-break: break-word;
  overflow-wrap: break-word;
}

.wp-block[data-align="left"] > [data-type="core/embed"],
.wp-block[data-align="right"] > [data-type="core/embed"] {
  max-width: 360px;
  width: 100%;
}

.wp-embed-responsive .wp-has-aspect-ratio iframe {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  height: 100%;
  width: 100%;
}

.wp-block-group {
  box-sizing: border-box;
}

.wp-block-image img {
  height: auto;
  max-width: 100%;
  vertical-align: bottom;
}
.wp-block-image.has-custom-border img,
.wp-block-image img {
  box-sizing: border-box;
}
.wp-block-image.aligncenter {
  text-align: center;
}
.wp-block-image.alignfull img,
.wp-block-image.alignwide img {
  height: auto;
  width: 100%;
}
.wp-block-image.aligncenter,
.wp-block-image .aligncenter,
.wp-block-image.alignleft,
.wp-block-image .alignleft {
  display: table;
}
.wp-block-image.aligncenter > figcaption,
.wp-block-image .aligncenter > figcaption,
.wp-block-image.alignleft > figcaption,
.wp-block-image .alignleft > figcaption {
  display: table-caption;
  caption-side: bottom;
}
.wp-block-image .alignleft {
  float: left;
  margin: 0.5em 1em 0.5em 0;
}
.wp-block-image .aligncenter {
  margin-left: auto;
  margin-right: auto;
}

.wp-block-image :where([style*="border-top-color"]) {
  border-top-style: solid;
}
.wp-block-image :where([style*="border-right-color"]) {
  border-right-style: solid;
}
.wp-block-image :where([style*="border-bottom-color"]) {
  border-bottom-style: solid;
}
.wp-block-image :where([style*="border-left-color"]) {
  border-left-style: solid;
}
.wp-block-image :where([style*="border-width"]) {
  border-style: solid;
}
.wp-block-image :where([style*="border-top-width"]) {
  border-top-style: solid;
}
.wp-block-image :where([style*="border-right-width"]) {
  border-right-style: solid;
}
.wp-block-image :where([style*="border-bottom-width"]) {
  border-bottom-style: solid;
}
.wp-block-image :where([style*="border-left-width"]) {
  border-left-style: solid;
}
.wp-block-image figure {
  margin: 0;
}

ol,
ul {
  box-sizing: border-box;
}

@keyframes overlay-menu__fade-in-animation {
  0% {
    opacity: 0;
    transform: translateY(0.5em);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.has-text-align-center {
  text-align: center;
}

.aligncenter {
  clear: both;
}

.screen-reader-text {
  border: 0;
  clip: rect(1px, 1px, 1px, 1px);
  clip-path: inset(50%);
  height: 1px;
  margin: -1px;
  overflow: hidden;
  padding: 0;
  position: absolute;
  width: 1px;
  word-wrap: normal !important;
}
.screen-reader-text:focus {
  background-color: #ddd;
  clip: auto !important;
  clip-path: none;
  color: #444;
  display: block;
  font-size: 1em;
  height: auto;
  left: 5px;
  line-height: normal;
  padding: 15px 23px 14px;
  text-decoration: none;
  top: 5px;
  width: auto;
  z-index: 100000;
}

html :where([style*="border-top-color"]) {
  border-top-style: solid;
}
html :where([style*="border-right-color"]) {
  border-right-style: solid;
}
html :where([style*="border-bottom-color"]) {
  border-bottom-style: solid;
}
html :where([style*="border-left-color"]) {
  border-left-style: solid;
}
html :where([style*="border-width"]) {
  border-style: solid;
}
html :where([style*="border-top-width"]) {
  border-top-style: solid;
}
html :where([style*="border-right-width"]) {
  border-right-style: solid;
}
html :where([style*="border-bottom-width"]) {
  border-bottom-style: solid;
}
html :where([style*="border-left-width"]) {
  border-left-style: solid;
}
html :where(img[class*="wp-image-"]) {
  height: auto;
  max-width: 100%;
}
figure {
  margin: 0 0 1em;
}

/* test */
.su-u-clearfix::after {
  content: "";
  display: table;
  clear: both;
}
.su-u-trim > :first-child {
  margin-top: 0;
}
.su-u-trim > :last-child {
  margin-bottom: 0;
}

.su-accordion {
  margin-bottom: 1.5em;
}
.su-accordion .su-spoiler {
  margin-bottom: 0.5em;
}

.su-posts-default-loop .su-post {
  margin-bottom: 2.5em;
  line-height: 1.5;
}
.su-posts-default-loop .su-post:after {
  content: "";
  display: table;
  clear: both;
}
.su-posts-default-loop .su-post-thumbnail {
  float: left;
  display: block;
  width: 100px;
  height: 100px;
  margin-right: 1em;
}
.su-posts-default-loop .su-post-thumbnail img {
  max-width: 100px;
  max-height: 100px;
}
.su-posts-default-loop h2.su-post-title {
  clear: none;
  margin: 0 0 0.3em;
  font-size: 1.2em;
  font-weight: 700;
}
.su-posts-default-loop .su-post-meta {
  margin-bottom: 0.7em;
  font-size: 0.8em;
  opacity: 0.6;
}
.su-posts-default-loop .su-post-excerpt {
  margin-bottom: 0.5em;
}
.su-posts-default-loop .su-post-excerpt p:last-child {
  margin-bottom: 0;
}

.su-spoiler {
  margin-bottom: 1.5em;
}
.su-spoiler .su-spoiler:last-child {
  margin-bottom: 0;
}
.su-spoiler-title {
  position: relative;
  cursor: pointer;
  min-height: 20px;
  line-height: 20px;
  padding: 7px 7px 7px 34px;
  font-weight: 700;
  font-size: 13px;
}
.su-spoiler-title:focus {
  outline: currentColor thin dotted;
}
.su-spoiler-icon {
  position: absolute;
  left: 7px;
  top: 7px;
  display: block;
  width: 20px;
  height: 20px;
  line-height: 21px;
  text-align: center;
  font-size: 14px;
  font-family: ShortcodesUltimateIcons;
  font-weight: 300;
  font-style: normal;
  -webkit-font-smoothing: antialiased;
}
.su-spoiler-content {
  padding: 14px;
  transition: padding-top 0.2s;
  -ie-transition: padding-top 0.2s;
}

.su-spoiler-icon-chevron .su-spoiler-icon:before {
  content: "\\f078";
  font-family: "FontAwesome";
}
.su-spoiler-icon-chevron.su-spoiler-closed .su-spoiler-icon:before {
  content: "\\f054";
  font-family: "FontAwesome";
}

.su-spoiler-style-default > .su-spoiler-title {
  padding-left: 27px;
  padding-right: 0;
}
.su-spoiler-style-default > .su-spoiler-title > .su-spoiler-icon {
  left: 0;
}
.su-spoiler-style-default > .su-spoiler-content {
  padding: 1em 0 1em 27px;
}

.aps-each-icon {
  display: inline-block;
  position: relative;
}
.aps-each-icon a {
  display: block;
  position: relative;
  z-index: 555;
  border-bottom: none !important;
}
.aps-each-icon img {
  transition: opacity 0.3s ease-in-out;
}
.aps-each-icon a:hover img {
  opacity: 1 !important;
}
.aps-group-horizontal .aps-each-icon:first-child {
  margin-left: 0 !important;
}

.aps-social-icon-wrapper:before,
.aps-social-icon-wrapper:after {
  content: "";
  display: table;
}
.aps-social-icon-wrapper:after {
  clear: both;
}

`, "",{"version":3,"sources":["webpack://./src/assets/styles/feature.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,qBAAqB;EACrB,sBAAsB;EACtB,0BAA0B;EAC1B,8BAA8B;AAChC;AACA;EACE;IACE,4BAA4B;EAC9B;AACF;AACA;EACE,uBAAuB;AACzB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,qBAAqB;AACvB;AACA;EACE;IACE,2BAA2B;EAC7B;AACF;AACA;EACE;IACE,aAAa;IACb,YAAY;EACd;EACA;;IAEE,YAAY;EACd;AACF;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,aAAa;EACb,YAAY;AACd;AACA;;EAEE,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;;EAEE,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,SAAS;EACT,OAAO;EACP,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,sBAAsB;AACxB;AACA;;EAEE,sBAAsB;AACxB;AACA;EACE,kBAAkB;AACpB;AACA;;EAEE,YAAY;EACZ,WAAW;AACb;AACA;;;;EAIE,cAAc;AAChB;AACA;;;;EAIE,sBAAsB;EACtB,oBAAoB;AACtB;AACA;EACE,WAAW;EACX,yBAAyB;AAC3B;AACA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;AACzB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,mBAAmB;AACrB;AACA;EACE,uBAAuB;AACzB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,SAAS;AACX;;AAEA;;EAEE,sBAAsB;AACxB;;AAEA;EACE;IACE,UAAU;IACV,4BAA4B;EAC9B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,SAAS;EACT,8BAA8B;EAC9B,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,UAAU;EACV,kBAAkB;EAClB,UAAU;EACV,4BAA4B;AAC9B;AACA;EACE,sBAAsB;EACtB,qBAAqB;EACrB,eAAe;EACf,WAAW;EACX,cAAc;EACd,cAAc;EACd,YAAY;EACZ,SAAS;EACT,mBAAmB;EACnB,uBAAuB;EACvB,qBAAqB;EACrB,QAAQ;EACR,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,uBAAuB;AACzB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,mBAAmB;AACrB;AACA;EACE,uBAAuB;AACzB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,YAAY;EACZ,eAAe;AACjB;AACA;EACE,eAAe;AACjB;;AAEA,SAAS;AACT;EACE,WAAW;EACX,cAAc;EACd,WAAW;AACb;AACA;EACE,aAAa;AACf;AACA;EACE,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;AACtB;AACA;EACE,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,cAAc;EACd,WAAW;AACb;AACA;EACE,WAAW;EACX,cAAc;EACd,YAAY;EACZ,aAAa;EACb,iBAAiB;AACnB;AACA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,WAAW;EACX,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,YAAY;AACd;AACA;EACE,oBAAoB;AACtB;AACA;EACE,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;AACtB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,yBAAyB;EACzB,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,iCAAiC;AACnC;AACA;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,cAAc;EACd,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,oCAAoC;EACpC,gBAAgB;EAChB,kBAAkB;EAClB,mCAAmC;AACrC;AACA;EACE,aAAa;EACb,4BAA4B;EAC5B,gCAAgC;AAClC;;AAEA;EACE,gBAAgB;EAChB,0BAA0B;AAC5B;AACA;EACE,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,OAAO;AACT;AACA;EACE,uBAAuB;AACzB;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;AACpB;AACA;EACE,cAAc;EACd,kBAAkB;EAClB,YAAY;EACZ,8BAA8B;AAChC;AACA;EAGE,oCAAoC;AACtC;AACA;EACE,qBAAqB;AACvB;AACA;EACE,yBAAyB;AAC3B;;AAEA;;EAEE,WAAW;EACX,cAAc;AAChB;AACA;EACE,WAAW;AACb","sourcesContent":[".wp-block-columns {\n  display: flex;\n  margin-bottom: 1.75em;\n  box-sizing: border-box;\n  flex-wrap: wrap !important;\n  align-items: normal !important;\n}\n@media (min-width: 782px) {\n  .wp-block-columns {\n    flex-wrap: nowrap !important;\n  }\n}\n.wp-block-columns.are-vertically-aligned-top {\n  align-items: flex-start;\n}\n.wp-block-columns.are-vertically-aligned-center {\n  align-items: center;\n}\n.wp-block-columns.are-vertically-aligned-bottom {\n  align-items: flex-end;\n}\n@media (max-width: 781px) {\n  .wp-block-columns:not(.is-not-stacked-on-mobile) > .wp-block-column {\n    flex-basis: 100% !important;\n  }\n}\n@media (min-width: 782px) {\n  .wp-block-columns:not(.is-not-stacked-on-mobile) > .wp-block-column {\n    flex-basis: 0;\n    flex-grow: 1;\n  }\n  .wp-block-columns:not(.is-not-stacked-on-mobile)\n    > .wp-block-column[style*=\"flex-basis\"] {\n    flex-grow: 0;\n  }\n}\n.wp-block-columns.is-not-stacked-on-mobile {\n  flex-wrap: nowrap !important;\n}\n.wp-block-columns.is-not-stacked-on-mobile > .wp-block-column {\n  flex-basis: 0;\n  flex-grow: 1;\n}\n.wp-block-columns.is-not-stacked-on-mobile\n  > .wp-block-column[style*=\"flex-basis\"] {\n  flex-grow: 0;\n}\n\n.wp-block-column {\n  flex-grow: 1;\n  min-width: 0;\n  word-break: break-word;\n  overflow-wrap: break-word;\n}\n\n.wp-block[data-align=\"left\"] > [data-type=\"core/embed\"],\n.wp-block[data-align=\"right\"] > [data-type=\"core/embed\"] {\n  max-width: 360px;\n  width: 100%;\n}\n\n.wp-embed-responsive .wp-has-aspect-ratio iframe {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  height: 100%;\n  width: 100%;\n}\n\n.wp-block-group {\n  box-sizing: border-box;\n}\n\n.wp-block-image img {\n  height: auto;\n  max-width: 100%;\n  vertical-align: bottom;\n}\n.wp-block-image.has-custom-border img,\n.wp-block-image img {\n  box-sizing: border-box;\n}\n.wp-block-image.aligncenter {\n  text-align: center;\n}\n.wp-block-image.alignfull img,\n.wp-block-image.alignwide img {\n  height: auto;\n  width: 100%;\n}\n.wp-block-image.aligncenter,\n.wp-block-image .aligncenter,\n.wp-block-image.alignleft,\n.wp-block-image .alignleft {\n  display: table;\n}\n.wp-block-image.aligncenter > figcaption,\n.wp-block-image .aligncenter > figcaption,\n.wp-block-image.alignleft > figcaption,\n.wp-block-image .alignleft > figcaption {\n  display: table-caption;\n  caption-side: bottom;\n}\n.wp-block-image .alignleft {\n  float: left;\n  margin: 0.5em 1em 0.5em 0;\n}\n.wp-block-image .aligncenter {\n  margin-left: auto;\n  margin-right: auto;\n}\n\n.wp-block-image :where([style*=\"border-top-color\"]) {\n  border-top-style: solid;\n}\n.wp-block-image :where([style*=\"border-right-color\"]) {\n  border-right-style: solid;\n}\n.wp-block-image :where([style*=\"border-bottom-color\"]) {\n  border-bottom-style: solid;\n}\n.wp-block-image :where([style*=\"border-left-color\"]) {\n  border-left-style: solid;\n}\n.wp-block-image :where([style*=\"border-width\"]) {\n  border-style: solid;\n}\n.wp-block-image :where([style*=\"border-top-width\"]) {\n  border-top-style: solid;\n}\n.wp-block-image :where([style*=\"border-right-width\"]) {\n  border-right-style: solid;\n}\n.wp-block-image :where([style*=\"border-bottom-width\"]) {\n  border-bottom-style: solid;\n}\n.wp-block-image :where([style*=\"border-left-width\"]) {\n  border-left-style: solid;\n}\n.wp-block-image figure {\n  margin: 0;\n}\n\nol,\nul {\n  box-sizing: border-box;\n}\n\n@keyframes overlay-menu__fade-in-animation {\n  0% {\n    opacity: 0;\n    transform: translateY(0.5em);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.has-text-align-center {\n  text-align: center;\n}\n\n.aligncenter {\n  clear: both;\n}\n\n.screen-reader-text {\n  border: 0;\n  clip: rect(1px, 1px, 1px, 1px);\n  clip-path: inset(50%);\n  height: 1px;\n  margin: -1px;\n  overflow: hidden;\n  padding: 0;\n  position: absolute;\n  width: 1px;\n  word-wrap: normal !important;\n}\n.screen-reader-text:focus {\n  background-color: #ddd;\n  clip: auto !important;\n  clip-path: none;\n  color: #444;\n  display: block;\n  font-size: 1em;\n  height: auto;\n  left: 5px;\n  line-height: normal;\n  padding: 15px 23px 14px;\n  text-decoration: none;\n  top: 5px;\n  width: auto;\n  z-index: 100000;\n}\n\nhtml :where([style*=\"border-top-color\"]) {\n  border-top-style: solid;\n}\nhtml :where([style*=\"border-right-color\"]) {\n  border-right-style: solid;\n}\nhtml :where([style*=\"border-bottom-color\"]) {\n  border-bottom-style: solid;\n}\nhtml :where([style*=\"border-left-color\"]) {\n  border-left-style: solid;\n}\nhtml :where([style*=\"border-width\"]) {\n  border-style: solid;\n}\nhtml :where([style*=\"border-top-width\"]) {\n  border-top-style: solid;\n}\nhtml :where([style*=\"border-right-width\"]) {\n  border-right-style: solid;\n}\nhtml :where([style*=\"border-bottom-width\"]) {\n  border-bottom-style: solid;\n}\nhtml :where([style*=\"border-left-width\"]) {\n  border-left-style: solid;\n}\nhtml :where(img[class*=\"wp-image-\"]) {\n  height: auto;\n  max-width: 100%;\n}\nfigure {\n  margin: 0 0 1em;\n}\n\n/* test */\n.su-u-clearfix::after {\n  content: \"\";\n  display: table;\n  clear: both;\n}\n.su-u-trim > :first-child {\n  margin-top: 0;\n}\n.su-u-trim > :last-child {\n  margin-bottom: 0;\n}\n\n.su-accordion {\n  margin-bottom: 1.5em;\n}\n.su-accordion .su-spoiler {\n  margin-bottom: 0.5em;\n}\n\n.su-posts-default-loop .su-post {\n  margin-bottom: 2.5em;\n  line-height: 1.5;\n}\n.su-posts-default-loop .su-post:after {\n  content: \"\";\n  display: table;\n  clear: both;\n}\n.su-posts-default-loop .su-post-thumbnail {\n  float: left;\n  display: block;\n  width: 100px;\n  height: 100px;\n  margin-right: 1em;\n}\n.su-posts-default-loop .su-post-thumbnail img {\n  max-width: 100px;\n  max-height: 100px;\n}\n.su-posts-default-loop h2.su-post-title {\n  clear: none;\n  margin: 0 0 0.3em;\n  font-size: 1.2em;\n  font-weight: 700;\n}\n.su-posts-default-loop .su-post-meta {\n  margin-bottom: 0.7em;\n  font-size: 0.8em;\n  opacity: 0.6;\n}\n.su-posts-default-loop .su-post-excerpt {\n  margin-bottom: 0.5em;\n}\n.su-posts-default-loop .su-post-excerpt p:last-child {\n  margin-bottom: 0;\n}\n\n.su-spoiler {\n  margin-bottom: 1.5em;\n}\n.su-spoiler .su-spoiler:last-child {\n  margin-bottom: 0;\n}\n.su-spoiler-title {\n  position: relative;\n  cursor: pointer;\n  min-height: 20px;\n  line-height: 20px;\n  padding: 7px 7px 7px 34px;\n  font-weight: 700;\n  font-size: 13px;\n}\n.su-spoiler-title:focus {\n  outline: currentColor thin dotted;\n}\n.su-spoiler-icon {\n  position: absolute;\n  left: 7px;\n  top: 7px;\n  display: block;\n  width: 20px;\n  height: 20px;\n  line-height: 21px;\n  text-align: center;\n  font-size: 14px;\n  font-family: ShortcodesUltimateIcons;\n  font-weight: 300;\n  font-style: normal;\n  -webkit-font-smoothing: antialiased;\n}\n.su-spoiler-content {\n  padding: 14px;\n  transition: padding-top 0.2s;\n  -ie-transition: padding-top 0.2s;\n}\n\n.su-spoiler-icon-chevron .su-spoiler-icon:before {\n  content: \"\\f078\";\n  font-family: \"FontAwesome\";\n}\n.su-spoiler-icon-chevron.su-spoiler-closed .su-spoiler-icon:before {\n  content: \"\\f054\";\n  font-family: \"FontAwesome\";\n}\n\n.su-spoiler-style-default > .su-spoiler-title {\n  padding-left: 27px;\n  padding-right: 0;\n}\n.su-spoiler-style-default > .su-spoiler-title > .su-spoiler-icon {\n  left: 0;\n}\n.su-spoiler-style-default > .su-spoiler-content {\n  padding: 1em 0 1em 27px;\n}\n\n.aps-each-icon {\n  display: inline-block;\n  position: relative;\n}\n.aps-each-icon a {\n  display: block;\n  position: relative;\n  z-index: 555;\n  border-bottom: none !important;\n}\n.aps-each-icon img {\n  -webkit-transition: opacity 0.3s ease-in-out;\n  -o-transition: opacity 0.3s ease-in-out;\n  transition: opacity 0.3s ease-in-out;\n}\n.aps-each-icon a:hover img {\n  opacity: 1 !important;\n}\n.aps-group-horizontal .aps-each-icon:first-child {\n  margin-left: 0 !important;\n}\n\n.aps-social-icon-wrapper:before,\n.aps-social-icon-wrapper:after {\n  content: \"\";\n  display: table;\n}\n.aps-social-icon-wrapper:after {\n  clear: both;\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
